"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Button_1 = require("@Components/Buttons/Button");
require("./index.scss");
const HeaderInfoBox = (props) => {
    const { imageType, heading, buttonText, buttonLink, btnClassName, children, isButton } = props;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: 'header-info-box' },
            react_1.default.createElement("img", { className: 'help-image', src: imageType, alt: 'Help Box Image' }),
            react_1.default.createElement("h5", null, heading),
            react_1.default.createElement("div", { className: 'box-info-body' },
                react_1.default.createElement(react_1.default.Fragment, null, children)),
            isButton && (react_1.default.createElement(Button_1.Button, { type: 'primary', mainColor: true, linkTo: buttonLink, typeLink: !!buttonLink, className: btnClassName, target: '_blank' }, buttonText)))));
};
exports.default = HeaderInfoBox;
